import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { MAT_NAME } from '../../boards/matConfigs';
import { setActiveBoard } from '../../RightColumn/RightMenu/rightMenuSlice';
import {
    StyledNav, NavItem, NavLink, Wrapper,
} from './styled';

const Navigation = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation();

    return (
        <Wrapper>
            <StyledNav>
                <NavItem onClick={() => dispatch(setActiveBoard(MAT_NAME))}>
                    <NavLink eventKey={MAT_NAME}>{t('mata 10 x 10')}</NavLink>
                </NavItem>
            </StyledNav>
        </Wrapper>
    );
};

export default Navigation;
